// extracted by mini-css-extract-plugin
module.exports = {"sliderContainer":"swipeableViews_sliderContainer__7ay9z","react-swipeable-view-container":"swipeableViews_react-swipeable-view-container___mFrA"};